export default "__VITE_ASSET__CKQMVLPb__";